export const environment = {
    production: false,
    develop: false,
    //apiSimpleLaundry: "http://localhost:3001/api",
    apiSimpleLaundry: "https://api-staging.simplelaundry.cl/api",
    keyCatchap: '6Lel7cseAAAAAFvKvpXyXaCsQToCRnx9voWO7nDJ',
};
